import React from 'react';
import { Helpers } from '../../core/src/helpers';
import DisclaimerTooltip from '../../shared/components/disclaimer-tooltip';


export default ({ type='default', content, classes="", disclaimers=[] }) => {
    const footnoteRegex = Helpers.footnoteRegex();
    const className = `content-${type}${classes.length > 0 ? ' '+classes : ''}`;
    return(
        <DisclaimerTooltip string={content} footnoteRegex={footnoteRegex} disclaimers={disclaimers}>
        {(string, replaced) => {
            return replaced ? <h1 className={className}>{string}</h1> : <h1 className={className} dangerouslySetInnerHTML={Helpers.createMarkup(string)}></h1>
        }}
        </DisclaimerTooltip>
    )
}
